import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import SessionModalAction from "@common/redux/actions/SessionModalAction";
import MachineSessionModalAction from "@common/redux/actions/MachineSessionModalAction";
import SessionalPositionsAction from "@common/redux/actions/SessionalPositionsAction";
import ButtonComponent from "../forms/ButtonComponent";
import useLogin from "@common/components/hooks/useLogin";
import { capitalized } from "../../helpers/labels";
import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";
import CustomerInteractionAction from "@common/redux/actions/CustomerInteractionAction";
import useLinkedSession from "../../hooks/useLinkedSession";

const ToggleLinkSession = (props) => {
  const { name } = props;
  const { control, resetField, setValue } = useFormContext();

  const handleModalClose = (linked) => {
    name === "session"
      ? SessionModalAction.reset()
      : MachineSessionModalAction.reset();
    if (!linked) resetField("linkSession", false);
  };

  const { linkedSessionData } = useLinkedSession();

  const linkedSessionGuids = linkedSessionData.map((x) =>
    x.sessionGuid.toString(),
  );

  const { activeRow } = useSelector((state) =>
    SessionalPositionsAction.getStatePath(state),
  );

  const [{ isInReadMode }] = useLogin();

  useEffect(() => {
    if (linkedSessionGuids) {
      setValue("sessionGuids", linkedSessionGuids, { shouldValidate: true });
      SessionModalAction.dispatch({ sessionGuids: linkedSessionGuids });
    }

    if (activeRow) {
      setValue(
        "machine",
        {
          installationGuid: activeRow.installationGuid,
        },
        {
          shouldValidate: true,
        },
      );
    }
  }, [linkedSessionData, activeRow, setValue]);

  return (
    <ButtonComponent
      control={control}
      name={name}
      disabled={isInReadMode}
      label={capitalized(name)}
      buttonName={`Select ${name}`}
      handleClick={() => {
        SuspiciousActivityAction.dispatch({ complianceAlertId: null });
        CustomerInteractionAction.dispatch({ complianceAlertId: null });
        name === "session"
          ? SessionModalAction.open(handleModalClose)
          : MachineSessionModalAction.open(handleModalClose);
      }}
    />
  );
};

export default ToggleLinkSession;
